import { useUpdateSession } from '@/hooks/useSession';
import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { useShallow } from 'zustand/react/shallow';

interface UpdateMemberInfo {
  phoneNumber: string;
  lastname: string;
  firstname: string;
  email: string;
  gender: string;
  dob: string;
  medicalReferral: string;
  preferredName: string;
}

export const useUpdateMemberSession = () => {
  const { trigger: triggerUpdateSession, isMutating: isUpdatingSession } = useUpdateSession();

  const { session, setSession } = usePrenuvoStore(
    useShallow((state) => ({
      session: state.scan.session,
      setSession: state.scan.methods.setSession,
    })),
  );

  const dispatchUpdateMemberSession = async ({
    phoneNumber,
    lastname,
    firstname,
    email,
    gender,
    dob,
    medicalReferral,
    preferredName,
  }: UpdateMemberInfo) => {
    const { locationId, skuId, eventId, timeSlot } = session;

    const sessionPayload = {
      member: {
        phoneNumber,
        lastname,
        firstname,
        email,
        gender,
        dob,
        medicalReferral: medicalReferral === 'true' ? true : false,
        preferredName: preferredName ?? undefined,
      },
      locationId,
      skuId,
      eventId,
      timeSlot,
    };

    const response = await triggerUpdateSession({ updatedSessionData: sessionPayload });
    if (response?.data?.updateSession?.status !== 200) {
      console.error('Failed to update session');
      return {
        error: `We've encountered an issue. Please clear your browser cookies and cache, then try again.
        If the issue persists, call us at +1\u00A0833\u00A0773\u00A06886 to complete your booking. We're happy to assist!`,
        status: false,
      };
    }

    setSession(response?.data?.updateSession?.session);
    return {
      status: true,
      exists: response?.data?.updateSession?.session?.member?.exists ?? false,
    };
  };

  return { dispatchUpdateMemberSession, isUpdatingSession };
};

export default useUpdateMemberSession;
